import React from 'react';
import { filter, map, sortBy } from 'lodash';

import {
  getOrderItemName,
  getShippingQuantity,
  isAddonProduct,
  isEquipment,
  isInventory,
  isStorageProduct,
  productHasZeroQuantity,
} from '@/components/modals/SubmitOrder/constants';
import { useOrderContext } from '@/components/modals/SubmitOrder/helpers';
import { OrderInventoryType } from '@/types';

import { DECOTECH_PRODUCT_NAME } from '../../../ConfirmationStep/helpers';
import { TIMBERLINE_TOOLS } from '../../constants';

import { Props } from './types';

import styles from '../../SuccessStep.module.scss';

export const SuccessOrderDetails = ({ isTimberline, productLineName }: Props) => {
  const state = useOrderContext();
  const isActivityDistributionModel = state.isDistribution;

  const selectedEquipment = filter(state.visibleOrderItems, oi => {
    if (
      productHasZeroQuantity(oi) ||
      (isEquipment(oi) &&
        isInventory(oi) &&
        (state.order.inventoryType === OrderInventoryType['Need Inventory'] ||
          productLineName === DECOTECH_PRODUCT_NAME))
    ) {
      return false;
    }

    return isEquipment(oi) || isStorageProduct(oi.priceBookEntry) || isAddonProduct(oi);
  });

  const orderedProducts = sortBy(selectedEquipment, oi => oi.priceBookEntry.product.type);

  if (isActivityDistributionModel) {
    return null;
  }

  return (
    <div className={styles.product_and_tools_block}>
      <span className={styles.block_title}>PRODUCTS</span>
      <hr />

      <div className={styles.products_list}>
        {map(orderedProducts, product => (
          <div className={styles.product_row} key={product.orderItem.productId}>
            <span>{getOrderItemName(product)}</span>
            <span className={styles.product_value}>
              {!isInventory(product) && getShippingQuantity(product)}
            </span>
          </div>
        ))}
      </div>

      {isTimberline && (
        <div className={styles.tools_section}>
          <br />
          <span className={styles.block_title}>TOOLS</span>
          <hr />
          <div className={styles.products_list}>
            {map(TIMBERLINE_TOOLS, tool => (
              <div className={styles.product_row} key={tool}>
                <span>{tool}</span>
                <span className={styles.product_value}>x1</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
